export default __webpack_public_path__ + "static/fa-light-300-fcf1da775bcce5c166a7052838400310.woff";